module.exports = __webpack_public_path__ + "static/img/logo04.f6003587.png";